import { createSlice } from "@reduxjs/toolkit";
import { USER_ERROR_MESSAGE } from "../../../constants/errorMessages";
import { fetchFavProducts } from "./apiThunk";
import { ToastNotifyError } from "../../../components/CommonComponents/Toast/ToastNotify";
import { extractProductValues } from "../../../utils/commonFuntions";

const initialState = {
  favProducts: [],
  favoriteCount: 0,
};

const favProductsSlice = createSlice({
  name: "favouriteProducts",
  initialState,
  reducers: {
    addFav: (state, action) => {
      state.favProducts = Array.isArray(state.favProducts) ? state.favProducts : [];

      if (!state.favProducts.includes(action.payload)) {
        state.favProducts = [...action.payload, ...state.favProducts];
        state.favoriteCount = state?.favProducts?.length || 0;
      }
    },
    removeFav: (state, action) => {
      state.favProducts = [...state.favProducts]?.filter((id) => id !== action.payload);
      state.favoriteCount = state?.favProducts?.length || 0;
    },
    clearAllFav: (state) => {
      state.favProducts = [];
      state.favoriteCount = 0;
    },
    setAllFav: (state, action) => {
      state.favProducts = [...action.payload];
      state.favoriteCount = action?.payload?.length || 0;
    },
    setFavoriteCount: (state, action) => {
      state.favoriteCount = action.payload;
    },
  },
    extraReducers: (builder) => {
    builder

      .addCase(fetchFavProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFavProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.favProducts = extractProductValues(action.payload?.data);
        state.favoriteCount = state?.favProducts?.length || 0;
      })
      .addCase(fetchFavProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.favoriteCount = 0;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      });
  },
});

const {
  actions: { addFav, removeFav, clearAllFav, setAllFav, setFavoriteCount },
  reducer,
} = favProductsSlice;

const selectorfavouriteProducts = (state) => state.favouriteProducts;

export { addFav, removeFav, clearAllFav, selectorfavouriteProducts, setAllFav, setFavoriteCount };

export default reducer;
